/** Family 1: the grid bookcase (plan §4.6). */
import type { Design } from '../../domain/schemas';
import type { ConstructionProfile } from '../../domain/profiles';
import jointsJson from './joints.json' with { type: 'json' };
import type { Family } from '../registry-types';
import { GRID_DEFINITION } from './definition';
import { deriveBuild } from './generate';
import { checkGridParams, GRID_INTAKE, gridDesignFromFit, gridFitSummary, type GridFitParams } from './intake';
import { createDesign, type PresetKey } from './design';

export const GRID_FAMILY: Family<GridFitParams> = {
  definition: GRID_DEFINITION,
  jointsJson,
  intake: GRID_INTAKE,
  generate: (design: Design, stock, construction?: ConstructionProfile) => deriveBuild(design, stock, construction),
  checkParams: checkGridParams,
  designFromFit: gridDesignFromFit,
  fitSummary: gridFitSummary,
  create: (presetId?: string) => createDesign((presetId as PresetKey) ?? 'even'),
};

export * from './definition';
export * from './design';
export * from './generate';
export * from './intake';
export * from './constraints';
